import React, { useState } from 'react'
import { withRouter } from 'react-router-dom';
import './WarningPage.scss';
import { Modal, Container, Row, Col, Form, Button, Image } from 'react-bootstrap';
import { WARNING_PANDA } from '../../images/images';
import Footer from '../Footer/Footer';

function WarningPage(props) {

    const [dateDay, setDateDay] = useState(1);
    const [dateMonth, setDateMonth] = useState(0);
    const [dateYear, setDateYear] = useState(new Date().getFullYear());
    const [ofAge, setOfAge] = useState(18);

    const countries = [
        {value: 0, name: 'Venezuela', ofAge: 18},
        {value: 1, name: 'España', ofAge: 18}
    ];

    const handleChangeDate = (type) => (e) => {
        const value = e.currentTarget.value;
        switch (type) {
            case 'day':
                setDateDay(value);
                break;
            case 'month':
                setDateMonth(value);
                break;
            case 'year':
                setDateYear(value);
                break;
            default:
                break;
        }
    }

    const handleChangeCountry = (e) => {
        const value = e.currentTarget.value;
        setOfAge(value);
    }

    const isOfAge = () => {
        const currentDate = Date.now();
        const userDate = new Date(dateYear, dateMonth, dateDay).getTime();
        return Math.abs(new Date(currentDate - userDate).getFullYear() - 1970) >= ofAge;
    }

    const enterPage = () => {
        sessionStorage.setItem('ofAge', true);
        props.history.push('/');
    }

    const renderDateList = (type) => {
        switch (type) {
            case 'day':
                const days = [];
                let startDay = 1;
                while ( startDay <= 31 ) {
                    days.push(startDay++);
                }
                return days.map(entry => (<option key={entry} value={entry}>{entry}</option>));

            case 'year':
                const years = [];
                const currentYear = new Date().getFullYear();
                let startYear = 1950;  
                while ( startYear <= currentYear ) {
                    years.push(startYear++);
                }
                years.sort((a, b) => (b - a));
                return years.map(entry => (<option key={entry} value={entry}>{entry}</option>));

            default:
                break;
        }
    }

    return (
        <div className="warning-page">
            <Modal.Dialog centered={true} className="warning-modal">
                <Modal.Body className="warning-modal-body">
                    <Form >
                        <div>¿Eres mayor de 18 años?</div>
                        <Container>
                            <Row>
                                <Col xs="12" md="4">
                                    <Form.Control className="warning-form" size="sm" as="select" onChange={handleChangeDate('day')}>
                                        {renderDateList('day')}
                                    </Form.Control>
                                </Col>
                                <Col xs="12" md="4">
                                    <Form.Control className="warning-form" size="sm" as="select" onChange={handleChangeDate('month')}>
                                        <option value="0">Enero</option>
                                        <option value="1">Febrero</option>
                                        <option value="2">Marzo</option>
                                        <option value="3">Abril</option>
                                        <option value="4">Mayo</option>
                                        <option value="5">Junio</option>
                                        <option value="6">Julio</option>
                                        <option value="7">Agosto</option>
                                        <option value="8">Septiembre</option>
                                        <option value="9">Octubre</option>
                                        <option value="10">Noviembre</option>
                                        <option value="11">Diciembre</option>
                                    </Form.Control>
                                </Col>
                                <Col xs="12" md="4">
                                    <Form.Control className="warning-form" size="sm" as="select" onChange={handleChangeDate('year')}>
                                        {renderDateList('year')}
                                    </Form.Control>
                                </Col>
                            </Row>
                        </Container>
                        <div className="divisor"/>
                        <div>Coloca el país donde te encuentras</div>
                        <Row>
                            <Col xs="12" md={{offset: 2, span: 8}}>
                                <Form.Control className="warning-form country" size="sm" as="select" onChange={handleChangeCountry}>
                                    {countries.map(
                                        entry => (<option key={entry.value} value={entry.ofAge}>{entry.name}</option>)
                                    )}
                                </Form.Control>
                            </Col>
                        </Row>
                        <Button className="warning-button fill" disabled={!isOfAge()} onClick={enterPage}>
                            Entrar
                        </Button>
                    </Form>
                    <Image src={WARNING_PANDA} height={100}/>
                </Modal.Body>
            </Modal.Dialog>
            <Footer fixed="bottom" page="warning" />
        </div>
    )
}

export default withRouter(WarningPage);